import { DeliveriesRequestFilters, HistoricalSwitch } from 'api/models/Deliveries';
import { useActionItemsFilters } from './useActionItemsFilters';
import { useDeliveries as useDeliveriesApi } from 'api/hooks/useDeliveries';
import { DeliveriesActionItemData } from '../types';
import { useMemo } from 'react';

type Props = {
  filters?: Partial<DeliveriesRequestFilters>;
  data?: DeliveriesActionItemData | null;
  disabled?: boolean;
};

const useDeliveries = ({ filters: actionItemFilters, data: _data, disabled }: Props): DeliveriesActionItemData => {
  const [filters] = useActionItemsFilters();

  const { data, isLoading } = useDeliveriesApi(
    {
      ...filters,
      limit: '100',
      historical: HistoricalSwitch.Active,
      ...actionItemFilters,
    },
    !!_data || disabled,
  );

  return useMemo(
    () =>
      _data || {
        data,
        isLoading,
        count: data?.result.length ?? 0,
        expressCount: data?.result.reduce((acc, item) => acc + (item.express ? 1 : 0), 0) ?? 0,
        total: data?.metadata.total ?? 0,
        search: filters.search ?? '',
      },
    [_data, data, filters.search, isLoading],
  );
};

export default useDeliveries;
